import { CustomError } from './custom.error';

export class LocalizableError extends CustomError {
    constructor(message: string, public resourceKey: string, public cause?: unknown) {
        super(message);
    }
}
